import { Button, Tooltip } from "@mui/material";
import React, { useState } from "react";
import EditUserRoleDialog from "../Dialogs/editUserRole";
import { Edit } from "@mui/icons-material";

export default function EditUserRoleButton(props) {
  const { user } = props;
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Tooltip title="Edit Role">
        <Button
          variant="outlined"
          color="info"
          onClick={() => setDialogOpen(true)}
          disabled={!user}
        >
          <Edit />
        </Button>
      </Tooltip>
      <EditUserRoleDialog
        open={dialogOpen}
        handleClose={() => setDialogOpen(false)}
        user={user}
      />
    </>
  );
}
